import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <Flex flexDirection="column" justifyContent="space-between">
      <div className="stacked-lg">
        <div style={{ width: "100%" }}>
          <Flex className={styles.bodyPadding} flexDirection="row" justifyContent="center">
            <div className={styles.bodyContainer}>
              <Text variant="h1">Customer care tools</Text>
              <Text variant="secondary-md" marginBottom="xl">
                Questions? Visit our <a href="https://help.junipersquare.com">Help Center</a>{" "}
                for resources.
              </Text>
              {children}
            </div>
          </Flex>
        </div>
      </div>
    </Flex>
  );
};

export default Layout;
